import { Controller } from "@hotwired/stimulus"

// Tabs inside the mobile bottom sheet. Buttons and panels are matched by
// a shared data-tab="<id>" attribute.
export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = { active: { type: String, default: "library" } }

  connect() {
    this.#sync()
  }

  select(event) {
    const tab = event.currentTarget.dataset.tab
    if (tab) this.activeValue = tab
  }

  activeValueChanged() {
    this.#sync()
  }

  #sync() {
    for (const btn of this.tabTargets) {
      const active = btn.dataset.tab === this.activeValue
      btn.setAttribute("aria-selected", active ? "true" : "false")
      btn.setAttribute("tabindex", active ? "0" : "-1")
      btn.classList.toggle("bg-indigo-600", active)
      btn.classList.toggle("text-white", active)
      btn.classList.toggle("border-indigo-600", active)
      btn.classList.toggle("text-neutral-700", !active)
    }
    for (const panel of this.panelTargets) {
      panel.classList.toggle("hidden", panel.dataset.tab !== this.activeValue)
    }
  }
}
